import * as React from "react";
import { ToolTipButton } from "nsitools-react";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { ERoutes } from "../../ERoutes";
import { useNavigationContext } from "../../contexts";
interface IBackButtonProps {
  backRoute: ERoutes | string;
}

export const BackButton: React.FunctionComponent<IBackButtonProps> = ({ backRoute }) => {
  const { t } = useTl();
  const { goBack } = useNavigationContext();

  return (
    <ToolTipButton
  tooltip={`${t(ETLCodes.General_GoBack)}`}
  icon="arrow-left"
  intent="primary"
  minimal={true}
  onClick={() => goBack(backRoute)}
  />
  );
};
